module.exports = __webpack_public_path__ + "0c45c2c9be0e78639b98b18eef792794.png";